import React, { useState } from 'react';
import { Table } from 'reactstrap';
import { TableWorkOrderItem } from './TableWorkOrderItem';

export const TableWorkOrder = (props) => {

    const {
        items,
        isEdit,
        count,
        removeExamProfile,
        handleCheckUrgent,
        handleCheckSpecimen,
        handleCheckForwarded,
        number_format,
        handleViewExamsProfile,
        checkTypeClient,
        listid,
        enable_tracking_toma,
        removeExamProfileByCampaign,
        handleChangeExternalLaboratories,
        validate_actions,
        _config_dashboard,
        allExams,
        validPorcentejeSpecial,
        cedimi,
        demo,
        _active_returnStudies,
        semlab

    } = props;


    // * CONFIGURATION DATATABLE
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: null
    });

    const handleSort = (key) => {
        let direction = 'asc';

        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        setSortConfig({ key, direction });
    };





    let wTest = [];
    let wCampaign = [];
    let wCampaignTmp = [];
    let wTestReferenced = [];


    wCampaignTmp = items.filter(x => x.is_campaign === true);



    if (wCampaignTmp.length > 0) {
        console.log("ENTRA A LOGS");
        wCampaignTmp.forEach(c => {
            let _find = wCampaign.find(x => x.id_common_discount === c.id_common_discount)
            console.log(_find)

            if (_find === undefined) {
                wCampaign.push({
                    id_common_discount: c.id_common_discount,
                    name_campaign: c.name_campaign,
                    list_test: [c]
                });
            }
            else {
                _find.list_test.push(c);
            }
        });
    }

    if (items.length > 0) {
        console.log("*", items);

        wTest = items.filter(x => x.is_campaign === false && x.is_referenced === false);
        wCampaignTmp = items.filter(x => x.is_campaign === true);
        wTestReferenced = items.filter(x => x.is_referenced === true)


    }


    console.log(wCampaignTmp);


    const sortedTests = [...wTest].sort((a, b) => {
        if (!sortConfig.key) return 0;

        let aValue = a[sortConfig.key];
        let bValue = b[sortConfig.key];

        if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    const showUrgenteColumn = sortedTests.some(x => x.id_agreement === null);

    const showUrgenteColumnReferenced = wTestReferenced.some(x => x.id_agreement === null);


    const showUrgenteGlobal =
        sortedTests.some(x => x.id_agreement === null) ||
        wTestReferenced.some(x => x.id_agreement === null);



    return (
        <div className="wo-wrapper">
            <div className="table-responsive">
                <Table className="wo-table">
                    <thead>
                        <tr>
                            <th style={{ width: "70px" }}>Código</th>
                            <th onClick={() => handleSort("name")} className="sortable">
                                Exámen / Perfil{" "}
                                <i
                                    className={`pi ${sortConfig.key === "name"
                                        ? (sortConfig.direction === "asc"
                                            ? "pi-sort-amount-up"
                                            : "pi-sort-amount-down")
                                        : "pi-sort-alt"
                                        }`}
                                    style={{ fontSize: "0.75rem" }}
                                ></i>
                            </th>
                            <th style={{ width: "90px" }} className="text-center">
                                Costo
                            </th>

                            {showUrgenteGlobal && (
                                <th style={{ width: "70px" }} className="text-center">
                                    {validPorcentejeSpecial === cedimi || validPorcentejeSpecial === demo
                                        ? "Guardia"
                                        : "Urgente"}
                                </th>
                            )}

                            {(enable_tracking_toma !== true && enable_tracking_toma !== "True") && (
                                <th style={{ width: "140px" }} className="text-center">
                                    Muestra
                                </th>
                            )}

                            {(enable_tracking_toma === true || enable_tracking_toma === "True") && (
                                <th style={{ width: "140px" }} className="text-center">
                                    Remitida
                                </th>
                            )}

                            {checkTypeClient === 3 && (
                                <th style={{ width: "110px" }} className="text-center">
                                    Convenio
                                </th>
                            )}
                            {(!isEdit || allExams !== "true") && (
                                <th style={{ width: "90px" }} className="text-center">
                                    Acciones
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            // * NEW ORDER
                        }
                        {sortedTests.length > 0 && sortedTests.map((itemTest, index) => (
                            <TableWorkOrderItem
                                key={`test-${itemTest.id_exam}-${index}`}
                                uniqueKey={`test-${itemTest.id_exam}-${index}`}
                                {...{
                                    itemTest,
                                    index,
                                    removeExamProfile,
                                    number_format,
                                    handleCheckSpecimen,
                                    handleCheckForwarded,
                                    checkTypeClient,
                                    handleCheckUrgent,
                                    handleViewExamsProfile,
                                    listid,
                                    enable_tracking_toma,
                                    removeExamProfileByCampaign,
                                    showUrgenteColumn,
                                    isEdit,
                                    count,
                                    validate_actions,
                                    _config_dashboard,
                                    allExams,
                                    _active_returnStudies
                                }}
                            />
                        ))}
                        {
                            // * CAMPAIGN ORDER
                        }

                        {wCampaign.length > 0 && wCampaign.map((itemCampaign, i) => (
                            itemCampaign.list_test.map((itemTest, index) => (
                                <TableWorkOrderItem
                                    key={`camp-${itemCampaign.id_campaign || i}-${itemTest.id_exam}-${index}`}
                                    uniqueKey={`camp-${itemCampaign.id_campaign || i}-${itemTest.id_exam}-${index}`}
                                    rowsSpan={itemCampaign.list_test.length}
                                    availableRowsSpan={true}
                                    availableByIndex={index}
                                    nameCampaign={itemCampaign.name_campaign}
                                    {...{
                                        itemTest,
                                        index,
                                        removeExamProfile,
                                        number_format,
                                        handleCheckSpecimen,
                                        handleCheckForwarded,
                                        checkTypeClient,
                                        handleCheckUrgent,
                                        handleViewExamsProfile,
                                        listid,
                                        enable_tracking_toma,
                                        removeExamProfileByCampaign,
                                        showUrgenteColumn,
                                        _active_returnStudies,
                                        isEdit,
                                        validPorcentejeSpecial,
                                        semlab

                                    }}
                                />
                            ))
                        ))}

                    </tbody>

                    <tfoot className={wTestReferenced.length > 0 ? "" : "d-none"}>
                        <tr>
                            <td
                                colSpan="6"
                                className="text-start "
                                style={{ fontSize: "11px", padding: "4px", color: "#002940", fontWeight: "700" }}
                            >
                                <i className='pi pi-file-import' ></i>&nbsp;
                                <label className='wo-tittle-exams' >
                                    Estudios de referencia
                                </label>
                            </td>
                        </tr>
                        {
                            // * REFERENCED ORDER
                        }
                        {wTestReferenced.length > 0 && wTestReferenced.map((itemReferenced, indexRef) => (
                            <TableWorkOrderItem
                                key={`ref-${itemReferenced.id_exam}-${indexRef}`}
                                uniqueKey={`ref-${itemReferenced.id_exam}-${indexRef}`}
                                {...{
                                    itemTest: itemReferenced,
                                    index: indexRef,
                                    removeExamProfile,
                                    number_format,
                                    handleCheckSpecimen,
                                    handleCheckForwarded,
                                    checkTypeClient,
                                    handleCheckUrgent,
                                    handleViewExamsProfile,
                                    listid,
                                    enable_tracking_toma,
                                    removeExamProfileByCampaign,
                                    handleChangeExternalLaboratories,
                                    showUrgenteColumn: showUrgenteColumnReferenced,
                                    isEdit,
                                    count,
                                    validate_actions,
                                    _config_dashboard,
                                    allExams,
                                    _active_returnStudies,
                                    semlab,
                                    validPorcentejeSpecial
                                }}
                            />
                        ))}
                    </tfoot>
                </Table>
            </div>
        </div >
    )
}

